import { tv } from "@fanka/tailwind-variants";
import { clsx } from "clsx";

export const NUM_BUTTON_CLASS_NAME = tv({
  base: "h-[36px] w-[36px] rounded border text-ui16 font-bold",
  variants: {
    active: {
      true: "border-ui-500 bg-ui-500 text-base-0",
      false: clsx(
        "border-ui-300",
        // hover
        "hover:bg-ui-300 hover:border-ui-300 hover:text-base-0",
      ),
    },
  },
});

export const ARROW_BUTTON_CLASS_NAME = tv({
  base: "h-[36px] w-[36px] text-center rounded-full p-[6px]",
  variants: {
    disabled: {
      true: "[&_svg]:fill-grayScale-200",
      false: clsx(
        "[&_svg]:hover:fill-grayScale-0",
        // hover
        "hover:bg-ui-300 hover:text-base-0",
      ),
    },
  },
});
